import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import AddTag from "../../../containers/superadmin/tags/models/add-tag";
import SearchBar from "../../../containers/superadmin/tags/searchbar";
import TagsTable from "../../../containers/superadmin/tags/table";
import { getAllTagsRequest } from "../../../modules/superadmin-modules/tags/Actions";

const SuperAdminTags = () => {
  const dispatch = useDispatch();
  const model = useSelector((state) => state.model);
  const [isAdd, setAdd] = useState(false);
  const [selectedData, setSelectedData] = useState({});

  useEffect(() => {
    dispatch(getAllTagsRequest());
  }, []);

  return (
    <Layout>
      <SearchBar setAdd={setAdd} setSelectedData={setSelectedData} />
      <TagsTable setAdd={setAdd} setSelectedData={setSelectedData} />
      <AddTag
        isAdd={isAdd}
        data={selectedData}
        setSelectedData={setSelectedData}
      />
    </Layout>
  );
};

export default SuperAdminTags;
